import React, { useEffect } from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import Modal from "../../../components/Modal";
import CategoryTree from "./CategoryTreeWrapper";
import { useTranslation } from "../../../langs/useTranslation";
import { toast } from "../../../apis/request";
import MemoedHOC from "@/hoc/MemoedHOC";

function TransferGroupModal({
  open,
  selectedGroupId,
  onSelect,
  onConfirm,
  onClose
}) {
  const { t } = useTranslation();
  const [checked, setChecked] = React.useState(false);
  const [checkedKeys, setCheckedKeys] = React.useState([]);

  const handleConfirm = () => {
    if (!checkedKeys.length) {
      toast.info(t({ defaultMessage: "请选择一个门店" }));
      return;
    }
    return onConfirm?.(checkedKeys, checked);
  };

  const handleSelect = (checkedKeys, info) => {
    setCheckedKeys(checkedKeys);
    onSelect?.(checkedKeys, info, checked);
  };

  useEffect(() => {
    if (selectedGroupId && open) {
      setCheckedKeys([selectedGroupId]);
    }
  }, [selectedGroupId, open]);

  useEffect(() => {
    if (open) {
      setChecked(false);
    }
  }, [open]);

  return (
    <Modal
      title={t({ defaultMessage: "转移门店" })}
      width={576}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <CategoryTree
        showAll={false}
        showSwitch={false}
        collapse={false}
        selectedKeys={checkedKeys}
        withPermission
        readOnly
        onSelect={handleSelect}
      />
      {/* <div style={{ marginBottom: -57, width: 170 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={e => setChecked(e.target.checked)}
            />
          }
          label={t({ defaultMessage: "转移后卸载app" })}
        />
      </div> */}
    </Modal>
  );
}

export default MemoedHOC(TransferGroupModal);
